module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('el-row', {
    staticClass: "container not-print"
  }, [_c('el-col', {
    staticClass: "header",
    staticStyle: {
      "position": "fixed",
      "z-index": "999"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('span', {
    staticStyle: {
      "margin-left": "20px",
      "font-size": "20px"
    }
  }, [_vm._v("用电安全物联网平台")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 19
    }
  }, [_c('el-row', [_c('el-col', {
    staticClass: "mgl30",
    attrs: {
      "span": 2
    }
  }, [_c('router-link', {
    staticClass: "menu-item my-tab-item",
    class: {
      'menu-item-actived': _vm.$route.path == '/'
    },
    attrs: {
      "to": "/",
      "tag": "div"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/volume.png"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "caption"
  }, [_vm._v("设备监控")])])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "mgl30",
    attrs: {
      "span": 2
    }
  }, [_c('router-link', {
    staticClass: "menu-item my-tab-item",
    class: {
      'menu-item-actived': _vm.$route.path == '/event'
    },
    attrs: {
      "to": "/event",
      "tag": "div"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/caution.png"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "caption"
  }, [_vm._v("报警事件")])])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "mgl30",
    attrs: {
      "span": 2
    }
  }, [_c('router-link', {
    staticClass: "menu-item my-tab-item",
    class: {
      'menu-item-actived': _vm.$route.path == '/his'
    },
    attrs: {
      "to": "/his",
      "tag": "div"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/clipboard.png"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "caption"
  }, [_vm._v("历史数据")])])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "mgl30",
    attrs: {
      "span": 2
    }
  }, [_c('router-link', {
    staticClass: "menu-item my-tab-item",
    class: {
      'menu-item-actived': _vm.$route.path.startsWith('/report')
    },
    attrs: {
      "to": "/report",
      "tag": "div"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/trends.png"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "caption"
  }, [_vm._v("诊断报告")])])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "mgl30",
    attrs: {
      "span": 2
    }
  }, [_c('router-link', {
    staticClass: "menu-item my-tab-item",
    class: {
      'menu-item-actived': _vm.$route.path.startsWith('/energy')
    },
    attrs: {
      "to": "/energy/active-power",
      "tag": "div"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/recycle.png"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "caption"
  }, [_vm._v("能效管理")])])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "mgl30",
    attrs: {
      "span": 2
    }
  }, [_c('router-link', {
    staticClass: "menu-item my-tab-item",
    class: {
      'menu-item-actived': _vm.$route.path == '/notice'
    },
    attrs: {
      "to": "/notice",
      "tag": "div"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/mail.png"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "caption"
  }, [_vm._v("系统通知")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative",
      "top": "-70px",
      "left": "16px"
    }
  }, [_c('el-badge', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.unreadCount > 0),
      expression: "unreadCount > 0"
    }],
    staticClass: "item",
    attrs: {
      "value": _vm.unreadCount
    }
  })], 1)])], 1), _vm._v(" "), (_vm.me.rname === 'ROLE_ADMIN') ? _c('el-col', {
    staticClass: "mgl30",
    attrs: {
      "span": 2
    }
  }, [_c('router-link', {
    staticClass: "menu-item my-tab-item",
    class: {
      'menu-item-actived': _vm.$route.path.startsWith('/settings')
    },
    attrs: {
      "to": "/settings/company",
      "tag": "div"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/profle.png"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "caption"
  }, [_vm._v("系统设置")])])], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
    staticClass: "mgl30",
    attrs: {
      "span": 2
    }
  }, [_c('div', {
    staticClass: "menu-item my-tab-item",
    on: {
      "click": _vm.logout
    }
  }, [_c('img', {
    attrs: {
      "src": "static/exit.png"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "caption"
  }, [_vm._v("登出系统")])])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding-top": "60px",
      "height": "100%",
      "box-sizing": "border-box"
    }
  }, [_c('el-col', {
    staticClass: "content-wrapper",
    attrs: {
      "span": 24
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67d32fd0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/NormalLayout.vue
// module id = 1310
// module chunks = 1